import { Col, SelectField } from '@/components';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import { ReviewTypeLabelModifier, reviewTypeEnum } from '@/utils/enum';
import { type FC, memo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const options = reviewTypeEnum.options.map((value) => ({
  value,
  label: ReviewTypeLabelModifier[value],
}));

export const InspectionByExternalExpertReviewTypeColField: FC = memo(() => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
  } = useFormContext<ProjectSearchFormType>();
  const sheetType = useWatch({
    control,
    name: 'sheetType',
  });
  const skipAdministrativeReformTeamEvaluation = useWatch({
    control,
    name: 'skipAdministrativeReformTeamEvaluation',
  });

  if (sheetType !== 'RS' || skipAdministrativeReformTeamEvaluation === 'true') {
    return null;
  }

  return (
    <Col span={8} style={{ minWidth: COL_MIN_WIDTH.large }}>
      <SelectField
        name="inspectionByExternalExpertReviewType"
        label={t('inspection-target')}
        control={control}
        errors={errors}
        mode="multiple"
        options={options}
      />
    </Col>
  );
});
